angular.module("angularAvant.controllers").controller "CustomerApplicationsContractCtrl", [
  "$scope", "$stateParams", "$controller", "CustomerApplicationService", "ApplicationService", "ProductService", "ConfigService", "ContractService", "$modal", "$timeout", "$window", '$q', '$sce', "AmountHelper"
  ($scope, $stateParams, $controller, CustomerApplicationService, ApplicationService, ProductService, ConfigService, ContractService, $modal, $timeout, $window, $q, $sce, AmountHelper) ->
    $scope.spinnerUrl = require('@amount/frontend-styles/src/images/dec/dec-loading.svg')
     # variable init
    $scope.page = "contract"
    $scope.contracts = []
    $scope.requirements = {}
    $scope.esign = {}
    $scope.spouse = {}
    $scope.spouse.first_name = ""
    $scope.spouse.last_name = ""
    $scope.errors = []
    $scope.showEditProduct = false
    $scope.hide_top_edit_terms = true
    $scope.message = ApplicationService.message
    $scope.rbd_is_required = ContractService.rbd_is_required
    $scope.rbd_consent = ContractService.rbd_consent
    $scope.selectedPaymentMethod = ''
    $scope.agreedToPaymentMethod = false
    $scope.agreedToRbd = false
    $scope.paymentMethodSubmitDisabled = true

    $scope.$emit('customer_application:data', ApplicationService.data)
    angular.extend($scope, $controller('CustomerApplicationsMixinCtrl', {$scope: $scope, CustomerApplicationService: CustomerApplicationService, ApplicationService: ApplicationService}))

    $scope.$on "$viewContentLoaded", ->
      $scope.tealiumView("#{$scope.page}_view", { application_page: $scope.page })

    $scope.addAttributeToElements = () ->
      $timeout ->
        elements = angular.element('.accordion-toggle')
        for element in elements
          do ->
            element.setAttribute("tabindex", "-1")
            element.setAttribute("aria-hidden", "true")

    $scope.showRiskBasedDisclosureModal = ->
      modalInstance = $modal.open(
        template: ContractService.rbd_html
        windowClass: 'remove-padding' # sets padding to 0 on the .remove-padding > .modal__fpo > .modal__content class for content that doesn't need the add'l spacing
        # Modal is non-dismissable during contract submission, as this would
        # take the customer out of the submission flow
        backdrop: if $scope.force_rbd_modal then 'static' else true
        controller: [
            "$scope", "$modalInstance", "rbd_consent", "force", "riskBasedDisclosureAlert", ($scope, $modalInstance, rbd_consent, force, riskBasedDisclosureAlert) ->
              $scope.rbd_consent = rbd_consent
              $scope.force = force
              $scope.riskBasedDisclosureAlert = riskBasedDisclosureAlert
              $scope.decline = ->
                if $scope.force
                  riskBasedDisclosureAlert()
                else
                  $modalInstance.close(false)
              $scope.accept = ->
                $modalInstance.close(true)
              $scope.print = ->
                w = $window.open();
                w.document.write("<body>#{ContractService.rbd_html}</body>
                                  <script>
                                    setTimeout(function () { window.print(); }, 500);
                                    setTimeout(function () { window.close(); }, 500);
                                  </script>");

          ]
        resolve:
          rbd_consent: -> $scope.rbd_consent
          force: -> $scope.force_rbd_modal
          riskBasedDisclosureAlert: -> $scope.riskBasedDisclosureAlert
      )
      deferred = $q.defer()
      modalInstance.result.then ((rbd_consent) ->
        $scope.setRiskBasedDisclosure(rbd_consent).then(() -> deferred.resolve())
      )
      deferred.promise

    $scope.needsToConsentToRiskBasedDisclosure = (force = false) ->
      if $scope.forceRbdAfterPaymentMethod() || $scope.displayRbdIfNotAccepted()
        $scope.force_rbd_modal ||= force

        # Temporary while we roll out RBD on amount modal for only HSBC, and others as a follow up
        if $scope.useAmountModal
          $scope.showRiskBasedDisclosureAmountModal()
        else
          $scope.showRiskBasedDisclosureModal()
      else
        # If the modal is not displayed, we don't need to wait for the API
        # request to complete, so just return a resolved promise
        $q.when()

    $scope.displayRbdIfNotAccepted = ->
      !$scope.config.force_rbd_after_payment_method && $scope.rbd_is_required && !$scope.rbd_consent

    $scope.forceRbdAfterPaymentMethod = ->
      $scope.config.force_rbd_after_payment_method && $scope.agreedToPaymentMethod && !$scope.agreedToRbd && $scope.rbd_is_required

    $scope.showRiskBasedDisclosureAmountModal = ->
      $scope.rbd_consent = false
      deferred = $q.defer()
      $scope.openAmountModal('risk_based_pricing_disclosure', {
        modalContent: $sce.trustAsHtml(ContractService.rbd_html)
        setRiskBasedDisclosure: $scope.setRiskBasedDisclosure
        deferred: deferred
        print: ->
          w = $window.open();
          w.document.write("<body>#{ContractService.rbd_html}</body>
                            <script>
                              setTimeout(function () { window.print(); }, 500);
                              setTimeout(function () { window.close(); }, 500);
                            </script>");
      })
      deferred.promise

    $scope.setRiskBasedDisclosure = (rbd_consent, deferred) ->
      $scope.rbd_consent = rbd_consent
      CustomerApplicationService.setRiskBasedDisclosure({ rbd_consent: rbd_consent }).then (response)->
        $scope.rbd_consent = response.data.rbd_consent
        # Due to the flow where RBD is displayed on every visit to payment method selection,
        # even if it was already accepted (which persists rbd_consent to the DB), using agreedToRbd
        # to keep track if RBD was accepted on each visit to payment method selection
        if $scope.config.force_rbd_after_payment_method
          $scope.agreedToRbd = response.data.rbd_consent
          if $scope.agreedToRbd
            $scope.closeAmountModal()
            $scope.tealiumView('contract_view_and_sign', { application_page: $scope.page })
            $scope.scrollToContract()
        deferred.resolve() if deferred

    $scope.riskBasedDisclosureAlert = ->
      if $scope.rbd_is_required && !$scope.rbd_consent
        alert "You Must Agree to the Risk-Based Pricing to Proceed."

    $scope.clearContracts = ->
      $scope.contracts = []

    $scope.spouseIsEitherNotRequiredOrWasCompleted = ->
      !$scope.spouse_required || (typeof($scope.spouse.exists) is "boolean")

    $scope.scrollToContract = (checkSpouse=true) ->
      $timeout ->
        contract_selector = _.find [
                              '.contract-frame-container'
                              '.app-form__iframe'
                            ], (selector) ->
                              $(selector) && $(selector).length > 0

        if contract_selector
          topOffset = $(contract_selector).offset().top - 100
          if checkSpouse && !$scope.spouseIsEitherNotRequiredOrWasCompleted() && $('#spouse-required-section').offset()
            topOffset = $('#spouse-required-section').offset().top - 120
          $("html,body").animate
            scrollTop: topOffset
          , 1000

    $scope.scrollToIframe = ->
      $timeout ->
        iframe_selector = _.find [
                              '.app-form__iframe'
                            ], (selector) ->
                              $(selector) && $(selector).length > 0

        if iframe_selector
          topOffset = $(iframe_selector).offset().top - 100
          $("html,body").animate
            scrollTop: topOffset
          , 1000


    $scope.$watch 'spouse.exists', (newValue, oldValue) ->
      if newValue is false
        $scope.scrollToContract(false)

    $scope.fetchNewContracts = ->
      $scope.$emit "submitDisabled", true
      $scope.loadingContracts = true
      ContractService.getContracts(ApplicationService.target_application_id()).then ->
        $scope.$emit "submitDisabled", false
        $scope.hasLoadedContractAtleastOnce = true
        $scope.downloadContractPaths = ContractService.downloadContractPaths
        $scope.loadingContracts = false
        $scope.contracts = ContractService.contracts
        $scope.contracts[0].visible = true
        $scope.spouse_required = ContractService.spouse_required
        $scope.show_payment_method_options = ContractService.show_payment_method_options
        $scope.print_contract_path = ContractService.print_contract_path
        $scope.scrollToContract(true) unless $scope.config.force_rbd_after_payment_method

    $scope.spouseAddressSameAsCustomer = ->
      $scope.spouse[k] ||= v for k, v of ApplicationService.data.customer_address

    $scope.signedContractIdentifiers = ->
      _.filter($scope.contracts, (c) -> c.signed )

    $scope.toggleContractAgree = (contract, force=null) ->
      _.map $scope.contracts, (c) ->
        (c.signed = if force is null then !c.signed else force) if c.identifier is contract.identifier
        c
      $scope.showContract($scope.topUnsignedContract())

    $scope.scrollToTop = ->
      $("html, body").clearQueue().animate({ scrollTop: 0 }, "fast") unless $scope.config.has_payment_method_agreement

    $scope.allContractsSigned = ->
      $scope.signedContractIdentifiers().length is $scope.contracts.length

    $scope.topUnsignedContract = ->
      unsignedContracts = _.filter($scope.contracts, (c) -> !c.signed )
      if unsignedContracts && unsignedContracts[0]
        unsignedContracts[0]
      else
        $scope.contracts[$scope.contracts.length - 1]

    $scope.showContract = (contract) ->
      $timeout ->
        angular.forEach $scope.contracts, (c) ->
          c.visible = c.identifier is contract.identifier
      , 100

    $scope.redirectToNextPage = ->
      $scope.$emit "submitDisabled", true
      ApplicationService.submitPage($scope.page, $scope.updateAllData()).then (response_data) ->
        $scope.redirectIfDifferentPage response_data, ->
        # some error occurred as page didn't change

    $scope.submit = (contract) ->
      $scope.markFieldsDirty()
      $scope.fireGtmSubmitEvent()
      $scope.$emit 'conversion:action', 'submit', 'contract'
      # set last contract to true on submit
      # Most applications have no validations on the contract page, so
      # checkValidations() won't do anything. TD has a consent checkbox and we
      # need to verify it's been checked before recording contract signature
      return unless $scope.checkValidations((() -> true), (() -> false))
      $scope.needsToConsentToRiskBasedDisclosure(true).then(->
        $scope.$emit 'customer_application:submit', $scope.page
        $scope.toggleContractAgree(contract, true)
        data =
          esign: $scope.esign
          contracts: $scope.contracts
          spouse: $scope.spouse
        if $scope.useAmountLoadingSpinner
          config = $scope.config?.version_config_data
          loadingMessage = AmountHelper.spinnerLoadingMessage(config, $scope.page)
          $scope.openAmountLoadingSpinner({ loadingMessage: loadingMessage })
        else
          CustomerApplicationService.createLoadingModal()
        ContractService.signContracts($scope.customer_application.id, data)
      ).then((response) ->
        $scope.clearServerSideErrors()
        if response.data.errors.length > 0
          $scope.closeAllLoadingModals()
          # Api::ContractController can throw errors in rare circumstances that
          # don't follow the proper format, which will cause showServerSideErrors()
          # to error out. This is a temporary workaround.
          if response.data.errors[0] is "There was an error."
            alert "There was an error signing your contract."
          else
            $scope.showServerSideErrors(response.data.errors)
        else if response.data.error_signing_contracts
          $scope.closeAllLoadingModals()
          alert response.data.error_signing_contracts
        else if response.data.application_complete
          $scope.tealiumEvent("#{$scope.page}_submit", { application_page: $scope.page })
          $scope.onContractSubmitSuccess()
        else
          $scope.redirectToNextPage()
      )

    $scope.onContractSubmitSuccess = ->
      CustomerApplicationService.goToStage('completed')

    $scope.$on 'modal.hide', ->
      $scope.fetchNewContracts()

    $scope.$on "contracts:signed_all", (event, data) ->
      $scope.signed_all_contracts = data


    $scope.$on 'customer_application:field_saved:product:payment_method:before_save', (event, val) ->
      $scope.$emit "submitDisabled", true
      $scope.clearContracts()
      $scope.loadingContracts = true

    $scope.$on 'customer_application:field_saved:product:payment_method:after_save', (event, val) ->
      $scope.$emit "submitDisabled", false
      $scope.fetchNewContracts()

    $scope.$on 'contract:clear', (event) ->
      $scope.clearContracts()

    $scope.$on 'autofill:fill', (_, autofillBroadcast) ->
      return unless autofillBroadcast.stage == 'contract'
      lodash.merge($scope, autofillBroadcast.data)

    # watchers
    $scope.$watch 'product.payment_method', (newValue, oldValue) ->
      if $scope.config.has_payment_method_agreement
        $scope.selectedPaymentMethod = newValue
        $scope.getPaymentMethodAgreement()
        if $scope.selectedAch()
          $scope.scrollToIframe()
      $scope.editingPaymentMethod = false
      if newValue isnt oldValue
        $scope.clearContracts()

    $scope.shouldDisplayPaymentMethodComponents = ->
      !$scope.selectedPaymentMethod || !$scope.agreedToPaymentMethod || (!$scope.agreedToRbd && $scope.rbd_is_required)

    $scope.returnToPaymentMethod = ->
      $scope.agreedToPaymentMethod = false
      $scope.agreedToRbd = false

    $scope.selectedAch = ->
      $scope.selectedPaymentMethod == 'ach'

    $scope.savePaymentMethod = ->
      $scope.openAmountLoadingSpinner(loadingMessage: 'Loading')
      $scope.update('product.payment_method').then (response) ->
        $scope.updatePaymentMethodAgreement()

    $scope.setHasAdminFeesFromProductData = (data) ->
      $scope.has_admin_fees = data.has_administration_fee

    $scope.getPaymentMethodAgreement = ->
      $scope.loadingPaymentMethodAgreement = true
      ContractService.getPaymentMethodAgreement(ApplicationService.data.customer_application.id).then (response) ->
        $scope.paymentMethodSubmitDisabled = false
        $scope.loadingPaymentMethodAgreement = false
        $scope.payment_agreement = ContractService.payment_agreement
        $scope.print_payment_agreement = ContractService.print_payment_agreement

    $scope.updatePaymentMethodAgreement = ->
      ContractService.updatePaymentMethodAgreement(ApplicationService.data.customer_application.id, $scope.selectedPaymentMethod).then (response) ->
        $scope.agreedToPaymentMethod = ContractService.agreedToPaymentMethod
        $scope.needsToConsentToRiskBasedDisclosure()
        $scope.closeAmountLoadingSpinner()

    ContractService.readyToViewContract(ApplicationService.data.customer_application.id).then (response) ->

      # Register Page View
      $scope.trackVisit()

      $scope.rbd_is_required = response.data.rbd_is_required
      $scope.rbd_consent = response.data.rbd_consent

      if response.data.can_view_contract is not true
        $window.location.replace("#{ConfigService.completePrefix}?customer_application_id=#{ApplicationService.target_application_id()}&reason=contract")
      else
        if ProductService.hasCompleteDetails()
          $scope.setHasAdminFeesFromProductData(ProductService.data)
          $scope.scrollToTop()
          $scope.needsToConsentToRiskBasedDisclosure()
          $scope.fetchNewContracts()
        else
          ProductService.getDetails(ApplicationService.data.customer_application.id).then((product_response) ->
            $scope.setHasAdminFeesFromProductData(product_response.data)
            $scope.scrollToTop()
            $scope.needsToConsentToRiskBasedDisclosure()
            $scope.fetchNewContracts()
          )
    , (error) ->
      $window.location.replace("#{ConfigService.completePrefix}?customer_application_id=#{ApplicationService.target_application_id()}&reason=contract")
]
